import { getLocale } from './localeUtils'

export const getOfferPdf = (offerHandouts, handoutVariant, marketType) => {
  if (!offerHandouts) {
    return null
  }

  const locale = getLocale()
  handoutVariant =
    handoutVariant ?? (marketType === 1 || locale === 'at' ? 1 : 3)

  const handoutArr = [
    { type: 'dennsTwelvePager', value: 1 },
    { type: 'twelvePagerMvp', value: 2 },
    { type: 'twelvePagerOvp', value: 3 }
  ]

  const customLinkArr = [
    'dennsTwelvePagerCustomLink',
    'twelvePagerMvpCustomLink',
    'twelvePagerOvpCustomLink'
  ]

  const selectedOfferItem = handoutArr.find(e => e.value === handoutVariant)

  if (selectedOfferItem) {
    const customLink = selectedOfferItem.value
    const ret = offerHandouts[customLinkArr[customLink - 1]]

    return ret
  }

  return null
}
